<template>
    <BaseSelect
      v-model="modelValue"
      v-bind="$attrs"
      :options="YES_NO_OPTIONS"      
      label="Authority Scope"
      :displayType="displayflex"
      size="sm"
      rules="required"      
    >
      <template v-slot:label>Above Authority Payment? <span class="text-danger">*</span> </template>
  
      <template v-slot:first>
        <b-form-select-option :value="undefined" disabled
          >Select</b-form-select-option
        >
      </template>
    </BaseSelect>
  </template>
  
  <script>
  import { defineComponent, computed } from '@vue/composition-api'  
  import { CASH_CALL_AUTHORITY_SCOPE_OPTIONS, YES_NO_OPTIONS } from '@constants'  
  import { BaseSelect } from '@components/base'
  
  export default defineComponent({
    name: 'CashCallAuthorityScope',
    components: {
      BaseSelect
    },
    props: {
      value: Boolean,
      displayType: String
    },
    emits: ['input'],
    setup(props, { emit }) {   
  
      const displayflex = "dropdownWidth-md"

      const modelValue = computed({
        get: () => props.value,
        set: (newValue) => emit('input', newValue)
      })   
  
      return {
        CASH_CALL_AUTHORITY_SCOPE_OPTIONS,
        YES_NO_OPTIONS,
        modelValue,
        displayflex
      }
    }
  })
  </script>
  